import React, { useState, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';

import { EditorContext } from '../Editor/index';
import { updateEditorBrandColor } from 'actions/editor';

import { CustomPicker } from 'react-color';
import { colorToString } from 'components/Editor/helper/color';

import styles from './color.module.scss';

import { Button, Tabs, Tab } from 'react-bootstrap';
import GradientColorSettings from './gradientSettings';
import { getColorsConfig } from 'services/cssHelper.service';
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';

const { Saturation, Hue, Alpha, EditableInput } = require('react-color/lib/components/common');

function CustomColorPicker(props) {

  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const colorType = _.get(props, 'type', 'solid');
  const [activeTab, setActiveTab] = useState(colorType == 'color' ? 'solid' : colorType);

  const swatchColors = [
    'rgb(208, 2, 27, 1)',
    'rgb(245, 166, 35, 1)',
    'rgb(248, 231, 28, 1)',
    'rgb(139, 87, 42, 1)',
    'rgb(126, 211, 33, 1)',
    'rgb(65, 117, 5, 1)',
    'rgb(189, 16, 224, 1)',
    'rgb(144, 19, 254, 1)',
    'rgb(74, 144, 226, 1)',
    'rgb(80, 227, 194, 1)',
    'rgb(184, 233, 134, 1)',
    'rgb(0, 0, 0, 1)',
    'rgb(74, 74, 74, 1)',
    'rgb(155, 155, 155, 1)',
    'rgb(255, 255, 255, 1)',
  ]

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession?.id;

  const brandColors = useSelector(state => { return _.get(state, `${editor}.present.brandTheme.colors`) || [] })
  const brandkitColourItems = useSelector(state => {
    const brandkit = _.get(state, 'palette.brandkit', {});
    const id = _.get(brandkit, 'items', []).find((brandkitItem) => brandkitItem.type === 'COLORS')?.id || "";
    return brandkit?.[`${id}`]?.items || [];
  });

  const handleAddColors = () => {

    var selectedColor = {
      r: _.get(props.rgb, 'r'),
      g: _.get(props.rgb, 'g'),
      b: _.get(props.rgb, 'b'),
      a: _.get(props.rgb, 'a')
    }

    var colorRequest = [
      ...brandColors,
      selectedColor
    ]

    if (_.size(colorRequest) > 15) {
      colorRequest.shift();
    }

    dispatch(updateEditorBrandColor(editor, colorRequest))
  }

  useEffect(() => {
    if (props.type === 'gradient') {
      setActiveTab('gradient')
    }
  }, [])

  const handleDelete = (colorCode) => {
    var removedColor = _.filter(brandColors, (color) => {
      return color !== colorCode
    });

    dispatch(updateEditorBrandColor(editor, removedColor))
  }

  return (
    <Tabs
      activeKey={activeTab}
      defaultActiveKey='solid'
      className={styles.customEditTabs}
      onSelect={(tab) => setActiveTab(tab)}
      fill
    >
      <Tab className={styles.tabDetailForm} eventKey="solid" title='Solid Color'>
        <div className={styles.container}>
          <div className={styles.saturationBox}>
            <Saturation
              {...props}
              onChange={(value) => props.onChange(value, activeTab)}
            />
          </div>
          <div className={styles.colorSliderWrapper}>
            <div className={styles.sliderBox}>
              <div className={styles.hueSlider}>
                <Hue
                  hsl={props.hsl}
                  onChange={(value) => props.onChange(value, activeTab)}
                  direction={'horizontal'}
                />
              </div>
              <div className={styles.alphaSlider}>
                <Alpha 
                  {...props}
                  onChange={(value) => props.onChange(value, activeTab)}
                  direction={'horizontal'} 
                />
              </div>
            </div>
            <div style={{ background: colorToString(props.rgb) }} className={styles.colorSwatch}></div>
          </div>
          <CustomInputFields {...props} activeTab={activeTab}/>
          {props?.brandkit === undefined && props?.showBrandkit !== false && (
            <div className={styles.brandColorSwatches}>
            <div className={styles.actionContainer}>
              <span className={styles.colorSwatchTitle}>Brand Colors</span>
              <span onClick={() => setEditMode(!editMode)} className={styles.actionButton}>{editMode ? "Done" : "Edit"}</span>
            </div>
            <div className={styles.colorSwatchWrapper}>
              <Button onClick={handleAddColors} disabled={editMode} className={styles.addButton} variant='info'>
                <i className={cx('cleverstory-plus', styles.addIcon)} />
              </Button>
              <ColorSwatchs colors={brandColors} editMode={editMode} onChange={props.onChange} handleDelete={handleDelete} activeTab={activeTab}/>
            </div>
          </div>
          )}
          <div className={styles.gloablColorDisplay}>
            <span className={styles.colorSwatchTitle}>Global Colors</span>
            <div className={styles.colorSwatchWrapper}>
              <ColorSwatchs colors={swatchColors} onChange={props.onChange} activeTab={activeTab}/>
            </div>
          </div>
          {!!editor?.length && !!brandkitColourItems?.length &&
            <BrandColors 
              brandkitColourItems={brandkitColourItems}
              onChange={props.onChange}
              activeTab={activeTab}
            />
          }
          <div className={styles.buttonTray}>
          </div>
        </div>
      </Tab>
      {props.gradient &&
        <Tab className={styles.tabDetailForm} eventKey="gradient" title='Gradient'>
          <div className={styles.container}>
            <GradientColorSettings {...props} swatchColors={swatchColors} brandColors={brandColors} handleDelete={handleDelete} handleAddColors={handleAddColors} activeTab={activeTab}/>
            {!!editor?.length && !!brandkitColourItems?.length &&
              <BrandColors 
                style={{marginTop: '-10px'}}
                brandkitColourItems={brandkitColourItems}
                onChange={props.onChange}
                activeTab={activeTab}
              />
            }
          </div>
        </Tab>}
    </Tabs>
  )
}

const BrandColors = ({
  style,
  brandkitColourItems,
  onChange,
  activeTab
}) => {
  return (
    <div style={style}>
      <div className={styles.paletteTitle}>
        <h3 className={styles.label}>BRAND COLOURS</h3>
        <hr className={styles.labelHighliter} />
      </div>
      {brandkitColourItems.map((item, index) => {
        const colors = item.draft.content.map((color) => getColorsConfig(color));
        return (
        <div className={cx(styles.gloablColorDisplay, {[styles.globalColorDisplayBorder]: index === 0})} key={item.id}>
          <TruncatedTextWithTooltip placement='top' maxWidth={235} content={_.get(item, "name", "")} className={styles.colorSwatchTitle} />
          <div className={styles.colorSwatchWrapper}>
            <ColorSwatchs colors={colors} onChange={onChange} activeTab={activeTab}/>
          </div>
        </div>
      )})}
    </div>
  )
}

const ColorSwatchs = ({ colors, editMode, onChange, handleDelete, activeTab }) => {
  return colors.map((color, index) => {
    return (
      <div key={index} className={cx(styles.colorBlock, { [styles.editMode]: editMode })}>
        <div
          onClick={() => {
            onChange(color, activeTab)
          }}
          key={color}
          className={cx(styles.colorSwatcher)}
          style={{ background: _.isObject(color) ? colorToString(color) : color }}
        />
        {editMode &&
          <Button onClick={() => handleDelete(color)} variant='info' className={styles.deleteOverlay}>
            <i className={cx('cleverstory-close')} />
          </Button>
        }
      </div>
    );
  })
}

export const CustomInputFields = ({ activeTab, ...props }) => {
  const [hexValue, setHexValue] = useState(`#`);
  const [redValue, setRedValue] = useState('');
  const [greenValue, setGreenValue] = useState('');
  const [blueValue, setBlueValue] = useState('');
  const [alphaValue, setAlphaValue] = useState('');
  const [handleHex, setHandleHex] = useState(false);
  const [handleRgb, setHandleRgb] = useState(false);
  const [Rgbatype, setRgbaType] = useState(null)

  const inputRefs = {
    r: useRef(null),
    g: useRef(null),
    b: useRef(null),
    a: useRef(null),
    hex: useRef(null)
  };

  const inputStyles = {
    input: {
      width: '80%',
      fontSize: '11px'
    },
    label: {
      fontSize: '11px',
      color: '#000000',
    },
  };

  useEffect(() => {
    if (!_.isEqual(props.hex, hexValue)) {
      if (props.hex === 'transparent') {
        setHexValue(`#FFFFFF`)
      } else if (!handleHex) {
        setHexValue(props.hex)
      } else {
        setHandleHex(false)
      }
    }
  }, [props.hex])

  useEffect(() => {
    const colorComponents = ['r', 'g', 'b', 'a'];
    const setters = [setRedValue, setGreenValue, setBlueValue, setAlphaValue];
    const values = [redValue, greenValue, blueValue, alphaValue];
  
    colorComponents.forEach((component, index) => {
      const propValue = _.get(props.rgb, component);
      if (!_.isEqual(propValue, values[index]) && !handleRgb && values[index] !=='') {
        const valueStr = values[3]?.toString();
        const isValidAlpha = !valueStr?.endsWith('.')
        if (index == 3) {
          isValidAlpha && setters[index](propValue);
        } else {
          setters[index](propValue);
        }
      } else {
        setHandleRgb(false);
      }
    });

  }, [props.rgb]);

  useEffect(() => {
    const colorComponents = ['r', 'g', 'b', 'a'];
    const setters = [setRedValue, setGreenValue, setBlueValue, setAlphaValue];
    const values = [redValue, greenValue, blueValue, alphaValue];
  
    colorComponents.forEach((component, index) => {
      const propValue = _.get(props.rgb, component);
      if (!_.isEqual(propValue, values[index]) && !handleRgb) {
        setters[index](propValue);
      } else {
        setHandleRgb(false);
      }
    });

  }, []);

  useEffect(() => {
    const activeElement = document.activeElement;
    const currentFocusedElement = activeElement?.getAttribute('class');
    const isTextEditor = currentFocusedElement && currentFocusedElement == "mce-content-body mce-edit-focus";

    if (Rgbatype !=null && isTextEditor) {
      document?.querySelector(`#focus${Rgbatype}`)?.focus();
    }

  },[document.activeElement])
  

  const handleHexColors = (e) => {
    const hexRegex = new RegExp(/^[0-9A-Fa-f]*$/);
    setHandleHex(true)
    setRgbaType('hex');
    let colorCode = e.target.value;

    if (e.type === 'paste') {
      e.preventDefault();

      colorCode = e.clipboardData.getData('Text').slice(0, 6);
    }

    if (colorCode === '' || colorCode === '#') {
      setHexValue('#');
      props.onChange({hex: `#ffffff`, source: 'hex'}, activeTab)
      return;
    }

    if (colorCode) {
      if (colorCode.includes('#')) {
        colorCode = colorCode.replace('#', '')
      }

      if (hexRegex.test(colorCode)) {
        setHexValue(`#${colorCode}`)
        if (colorCode.length == 3 || colorCode.length == 6) {
          props.onChange({hex: `#${colorCode}`, source: 'hex'}, activeTab)
        }
      }
    }
  }

  const handleRgbaChange = (e, type) => {
    setHandleRgb(true);
    setRgbaType(type);
    const { value } = e.target;

    const { color, onChange } = props;
    const rgbaRegex = type === 'a' ? /^[0-9]*\.?[0-9]*$/ : /^[0-9]*$/;
  
    if (!rgbaRegex.test(value)) {
      console.error("Invalid input: Only numbers are allowed.");
      return;
    }

    switch (type) {
      case 'r':
        setRedValue(value);
        break;
      case 'g':
        setGreenValue(value);
        break;
      case 'b':
        setBlueValue(value);
        break;
      case 'a':
        setAlphaValue(value);
        break;
      default:
        break;
    }

    const numericValue = value ? (type === 'a' ? value : parseInt(value, 10)) : 0
    const numericValueStr = numericValue.toString();

    if (typeof color === 'object' && numericValue !== '') {
      let alphaValue = parseFloat(numericValue);
      if (type === 'a') {
        if (numericValueStr?.includes(".") && numericValueStr?.length == 2 && !numericValueStr?.startsWith(".")){
        } else {
          const updatedColor = { ...color, source: "rgb", [type]: alphaValue };
          onChange(updatedColor, activeTab);
        }
      } else {
        const updatedColor = { ...color, source: "rgb", [type]: numericValue };
        onChange(updatedColor, activeTab);
      }
    } 
    else if (typeof color === 'string' && numericValue !== '') {
      const rgbaMatch = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(\.\d+)?))?\)$/);
      let alphaValue = parseFloat(numericValue);

      if (rgbaMatch) {
        const rgba = {
          r: parseInt(rgbaMatch[1], 10),
          g: parseInt(rgbaMatch[2], 10),
          b: parseInt(rgbaMatch[3], 10),
          a: parseFloat(rgbaMatch[4]),
          source: "rgb"
        };

        if (type === 'a') {
          if (numericValueStr?.includes(".") && numericValueStr?.length == 2 && !numericValueStr?.startsWith(".")){
          } else {
            rgba[type] = alphaValue;
            props.onChange(rgba, activeTab);
          }
        } else {
          rgba[type] = numericValue;
          props.onChange(rgba, activeTab);
        }
  
      } else {
        console.error("Invalid color format. Expected rgba string.");
      }
    }
  };

  return (
    <div className={styles.inputFieldsWrapper}>
      <div className={styles.hexCodeInput}>
        <input
          id='focushex'
          ref={inputRefs.hex}
          value={hexValue}
          className={styles.inputValue}
          onChange={handleHexColors}
          autoComplete="off"
          maxLength={7}
          onPaste={handleHexColors}
        />
        <span style={inputStyles.label} >Hex</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <input
          id='focusr'
          ref={inputRefs.r}
          value={redValue}
          className={styles.inputValue}
          autoComplete="off"
          maxLength={3}
          onChange={(e) => handleRgbaChange(e, 'r')}
        />
        <span style={inputStyles.label} >R</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <input
          id='focusg'
          ref={inputRefs.g}
          value={greenValue}
          className={styles.inputValue}
          autoComplete="off"
          maxLength={3}
          onChange={(e) => handleRgbaChange(e, 'g')}
        />
        <span style={inputStyles.label} >G</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <input
          id='focusb'
          ref={inputRefs.b}
          value={blueValue}
          className={styles.inputValue}
          autoComplete="off"
          maxLength={3}
          onChange={(e) => handleRgbaChange(e, 'b')}
        />
        <span style={inputStyles.label} >B</span>
      </div>
      <div className={styles.rgbaCodeInput}>
        <input
          id='focusa'
          ref={inputRefs.a}
          value={alphaValue}
          className={styles.inputValue}
          autoComplete="off"
          maxLength={4}
          onChange={(e) => handleRgbaChange(e, 'a')}
        />
        <span style={inputStyles.label} >A</span>
      </div>
    </div>
  )
};

export default CustomPicker(CustomColorPicker);